import Product from '../domains/Product'

export const getAddToWishlistExtraTrackingData = (
  product: Product | { shopifyProductId: number; internalProductId_color?: string; price?: number },
) => {
  if (!('id' in product)) return {}
  return {
    department: product.classification?.department?.name,
    department_id: product.classification?.department?.id,
    division: product.classification?.division?.name,
    division_id: product.classification?.division?.id,
    rating: product.productReviewSummary?.averageRating,
    rating_count: product.productReviewSummary?.reviewCount,
    subdepartment: product.classification?.subDepartment?.name,
    subdepartment_id: product.classification?.subDepartment?.id,
    title: product.title,
  }
}
